import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Item} from "../../models/Item";
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {MeasurementService} from "../../services/measurementAdapter/measurement.service";
import {ToolsService} from "../../services/toolsService/tools.service";
import {PerspectiveService} from "../../services/perspective/perspective.service";
import { isViewMode } from 'src/configs/view_only';
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
declare var Yiit;

@Component({
  selector: 'app-item-element',
  templateUrl: './item-element.component.html',
  styleUrls: ['./item-element.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemElementComponent implements OnInit {

  public Yiit = Yiit;

  @Input() item:Item;
  @Input() highlightedItemId;
  public hasMeasurement;
  public isViewMode = isViewMode;

  constructor(
    private itemManager: ItemManagerService,
    private cd: ChangeDetectorRef,
    protected uiAdapterService: UiAdapterService,
    private perspectiveService: PerspectiveService) { }

  ngOnInit() {
    // this.init();
    this.initListeners();
  }

  private initListeners(){
  }

  // private init(){
  //   this.hasMeasurement = this.measurementAdapter.hasMeasurement(this.item);
  // }

  isHighlightedItem(item){
    return this.highlightedItemId && item.getId() == this.highlightedItemId;
  }

  isDragAllowed(item){
    return item.config.getTool().is_draggable;
  }

  public centerMapAtObj(item){
    item.centerOnObj();
  }
  getItemMenuImage(item:Item){
    return item.config.getTool().menu_icon || null;
  }
  setTitle(item, event){
    item.setTitle(event.target.value);
  }

  toggleItemDrag(item:Item){
    clearTimeout(item.timer);
    console.log('toggleItemDrag', item);
    if (!this.uiAdapterService.globalDragEnabled) {
      if (item.drag_enabled) {
        item.drag_enabled = false;
        item.timer = null;
      } else {
        item.drag_enabled = true;
        item.timer = setTimeout(() => {
          this.cd.markForCheck();
          item.drag_enabled = false;
          item.timer = null;
        }, 30000)
      }
    }
    // item.is_dragged = !item.is_dragged;
  }

  getClasses(item: Item) {
    let classes = {'es-highlighted': this.isHighlightedItem(item)};
    let tool = item.config.getTool();

    if (tool && tool.hasOwnProperty('perspectives') && tool.perspectives) {
      for (let i in tool.perspectives) {
        if (tool.perspectives.hasOwnProperty(i)) {
          classes['perspective-' + tool.perspectives[i]] = true;
        }
      }
    }
    return classes;
  }

  hasPerspective(item: Item, perspective) {
    if (perspective) {
      let tool = item.config.getTool();
      if (tool && tool.hasOwnProperty('perspectives') && tool.perspectives) {
        if (tool.perspectives.indexOf(perspective) >= 0) {
          return true;
        }
      }
      return false;
    }
    return true;
  }

}
